import { InjectionToken } from '@angular/core';
import { WebActivityReportsPort } from './web-activity-reports.port';

export const WEB_REPORTS_PORT = new InjectionToken<WebActivityReportsPort>('WEB_REPORTS_PORT');